<template>
  <div>
    <template v-if="column === 'lostBenefitPercentage' && bookingItem.low_fare !== null && bookingItem.invoice_gross_value !== null">
      {{ parseFloat((bookingItem.lost_benefit / bookingItem.invoice_gross_value) * 100).toFixed(1) }} %
    </template>
    <template v-if="column === 'lostBenefit' && bookingItem.lost_benefit !== null">
      {{ parseFloat(bookingItem.lost_benefit).toFixed(2) }} {{ currency }}
    </template>
    <template v-if="column === 'fareBase' && bookingItem.fare_base !== null"> {{ parseFloat(bookingItem.fare_base).toFixed(2) }} {{ currency }} </template>
    <template v-if="column === 'name'">
      {{ bookingItem.name }}
    </template>
    <template v-if="column === 'airline_name'">
      {{ bookingItem.airline_name }}
    </template>
    <template v-if="column === 'compartment'">
      {{ bookingItem.compartment }}
    </template>
    <template v-if="column === 'airline_icao'">
      {{ bookingItem.airline_icao }}
    </template>
    <template v-if="column === 'airline_iata'">
      {{ bookingItem.airline_iata }}
    </template>
    <template v-if="column === 'low_fare' && bookingItem.low_fare !== null">{{ bookingItem.low_fare }} {{ currency }}</template>
    <template v-if="column === 'creation_date'">
      {{ formatDateView(bookingItem.creation_date) }}
    </template>
    <template v-if="column === 'reservation_number'">
      {{ bookingItem.reservation_number }}
      <v-chip label outlined small style="color: #FFE3F3; background-color: #ff99d0 !important;" v-if="bookingItem.is_cancelled === 1">
        {{ $t("booking.canceled") }}
      </v-chip>
    </template>
    <template v-if="column === 'route' && bookingItem.flightAttributes !== null">
      <div v-if="bookingItem.flightAttributes.start_airport_code == null">
        {{ bookingItem.flightAttributes.itinerary }}
        <div class="flight-date grey--text">
          {{ $t("booking.flight.missingDetailedInformation") }}
        </div>
      </div>
      <div v-else>
        <v-row>
          <v-col class="flight-part">
            <div class="flight-direction grey--text">
              {{ $t("booking.flight.departure") }}
            </div>
            <div class="flight-airport">
              <span class="bigger" style="font-weight: bold">
                <v-tooltip bottom color="white">
                  <template #activator="{on}">
                    <span class="accent--text" v-on="on">{{ bookingItem.flightAttributes.start_airport_code }}</span>
                  </template>
                  <span style="color: #0f0f0f">{{ bookingItem.flightAttributes.start_airport_name }}</span>
                </v-tooltip>
                <span class="arrow">➞</span>
                <v-tooltip bottom color="white">
                  <template #activator="{on}">
                    <span class="accent--text" v-on="on">{{ bookingItem.flightAttributes.end_airport_code }}</span>
                  </template>
                  <span style="color: #0f0f0f">{{ bookingItem.flightAttributes.end_airport_name }}</span>
                </v-tooltip>
              </span>
              {{ bookingItem.flightAttributes.start_time != null ? bookingItem.flightAttributes.start_time.substr(0, 5) : $t("global.noData") }}
              -
              {{ bookingItem.flightAttributes.end_time != null ? bookingItem.flightAttributes.end_time.substr(0, 5) : $t("global.noData") }}
            </div>
            <div class="flight-date grey--text">
              {{ bookingItem.flightAttributes.start_date != null ? dayOfWeek(bookingItem.flightAttributes.start_date.substr(0, 10)) : $t("global.noData") }}
              {{ bookingItem.flightAttributes.start_date != null ? formatDateView(bookingItem.flightAttributes.start_date) : $t("global.noData") }}
            </div>
          </v-col>
          <v-col class="flight-part" v-if="bookingItem.flightAttributes.return_start_airport_code != null">
            <div class="flight-direction grey--text">
              {{ $t("booking.flight.arrival") }}
            </div>
            <div class="flight-airport">
              <span class="bigger" style="font-weight: bold">
                <v-tooltip bottom color="white">
                  <template #activator="{on}">
                    <span class="accent--text" v-on="on">{{ bookingItem.flightAttributes.return_start_airport_code }}</span>
                  </template>
                  <span style="color: #0f0f0f">{{ bookingItem.flightAttributes.return_start_airport_name }}</span>
                </v-tooltip>
                <span class="arrow">➞</span>
                <v-tooltip bottom color="white">
                  <template #activator="{on}">
                    <span class="accent--text" v-on="on">{{ bookingItem.flightAttributes.return_end_airport_code }}</span>
                  </template>
                  <span style="color: #0f0f0f">{{ bookingItem.flightAttributes.return_end_airport_name }}</span>
                </v-tooltip>
              </span>
              {{ bookingItem.flightAttributes.return_start_time.substr(0, 5) }}
              -
              {{ bookingItem.flightAttributes.return_end_time.substr(0, 5) }}
            </div>
            <div class="flight-date grey--text">
              {{ dayOfWeek(bookingItem.flightAttributes.return_start_date.substr(0, 10)) }}
              {{ formatDateView(bookingItem.flightAttributes.return_start_date) }}
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-if="column === 'ticket_number' && bookingItem.flightAttributes !== null">
      {{ bookingItem.flightAttributes.ticket_number }}
    </template>
    <template v-if="column === 'passengers'">
      <!-- eslint-disable-next-line -->
      <span v-for="passenger of bookingItem.passengers" style="text-transform: capitalize"> {{ passenger }} <br /> </span>
    </template>
    <template v-if="column === 'sale_date'">
      <!-- eslint-disable-next-line -->
      {{ bookingItem.sale_date }}
    </template>
    <template v-if="column === 'issue_date'">
      <!-- eslint-disable-next-line -->
      {{ bookingItem.issue_date }}
    </template>
    <template v-if="column === 'invoice_number'">
      <!-- eslint-disable-next-line -->
      {{ bookingItem.invoice_number }}
    </template>
    <template v-if="column === 'grossSummary'">
      <span class="datatable-total-amount">
        <template v-if="bookingItem.invoice_gross_value !== null"
          >{{ parseFloat(bookingItem.invoice_gross_value).toFixed(2) }} {{ bookingItem.invoice_currency }}</template
        >
        <template v-else-if="bookingItem.total_amount !== null">{{ parseFloat(bookingItem.total_amount).toFixed(2) }} PLN</template>
      </span>
    </template>
    <template v-if="column === 'grossSummaryWithDiscount'">
      <span class="datatable-total-amount">
        <template v-if="bookingItem.invoice_gross_with_discount !== null">
          {{ parseFloat(bookingItem.invoice_gross_with_discount).toFixed(2) }} {{ bookingItem.invoice_currency }}
        </template>
      </span>
    </template>
    <template v-if="column === 'netSummary'">
      <span class="datatable-net-amount"> {{ parseFloat(bookingItem.invoice_net_value).toFixed(2) }} {{ bookingItem.invoice_currency }} </span>
    </template>
    <template v-if="column === 'discount' && bookingItem.discount !== null"> {{ parseFloat(bookingItem.discount).toFixed(2) }} {{ currency }} </template>
    <template v-if="column === 'organization_unit' && bookingItem.organization_unit !== null"> {{ bookingItem.organization_unit }} </template>
    <template v-if="column === 'airportCharges' && bookingItem.airport_taxes_and_fees !== null">
      {{ parseFloat(bookingItem.airport_taxes_and_fees).toFixed(2) }} {{ currency }}
    </template>
  </div>
</template>

<script>
import formatDateView from "../../../repository/fotmatDateView";
import moment from "moment";
import dayOfWeek from "../../../repository/shortDayOfWeekFromDate";

export default {
  name: "BookingReportDetailedItemComponent",
  props: {
    column: {
      required: true
    },
    selectedColumns: {
      required: true
    },
    currency: {
      required: true
    },
    bookingItem: {
      required: true
    }
  },
  methods: {
    dayOfWeek,
    localMoment: moment,
    formatDateView: formatDateView
  }
};
</script>

<style scoped>
.chip--small {
  height: 22px;
}

.flight-direction {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.grey--text {
  color: #9e9e9e !important;
}

.bigger {
  margin-right: 4px;
  font-size: 15px;
}

.flight-airport {
  font-weight: 700;
  line-height: 1;
}

.flight-part {
  min-width: 175px;
}
</style>
